/* global modForm */
import { showPrevStep } from '../../../helpers';

export function backButtonClickCallback(e) {
	e.stopImmediatePropagation();
	if (modForm.opts.isFormLoading || (modForm.opts.formSwiperInstance && modForm.opts.formSwiperInstance.animating)) {
		e.preventDefault();
	} else {
		showPrevStep();
		modForm.opts.clickedFormBackButton = true;
	}
}
